/* R28 hover card - quick add (+) behaviour and image fitting. Prefix: r28h.
   - "+" appears on image hover; clicking it opens the panel
   - panel lets the shopper pick colour / size, then adds to bag via the native side cart (window.R28Cart)
   - images taller than the card frame are scaled to fit (never cropped top/bottom) */
(function () {
  if (window.__r28hInit) return;
  window.__r28hInit = true;

  /* ---------- image fitting ---------- */
  function fitImages() {
    Array.prototype.forEach.call(document.querySelectorAll('.r28h__img:not([data-r28h-fit])'), function (img) {
      var media = img.closest('.r28h__media');
      var w = parseFloat(img.getAttribute('width'));
      var h = parseFloat(img.getAttribute('height'));
      if (!media || !w || !h) return;
      var box = media.getBoundingClientRect();
      if (!box.width || !box.height) return;
      img.setAttribute('data-r28h-fit', '1');
      // taller than the frame: "cover" would crop top and bottom, so fit the whole image instead
      img.classList.toggle('is-fit', (w / h) < (box.width / box.height) - 0.01);
    });
  }

  var fitQueued = false;
  function queueFit() {
    if (fitQueued) return;
    fitQueued = true;
    requestAnimationFrame(function () { fitQueued = false; fitImages(); });
  }

  fitImages();
  window.addEventListener('load', fitImages);
  if (window.MutationObserver && document.body) {
    new MutationObserver(queueFit).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- quick add ---------- */
  function getState(card) {
    if (card.__r28h) return card.__r28h;
    var variants = [];
    var json = card.querySelector('[data-r28h-variants]');
    try { variants = JSON.parse(json ? json.textContent : '[]'); } catch (e) { variants = []; }
    card.__r28h = {
      variants: variants,
      groups: Array.prototype.slice.call(card.querySelectorAll('[data-r28h-group]')),
      ready: false,
      variant: null
    };
    return card.__r28h;
  }

  function selection(st) {
    return st.groups.map(function (g) {
      var chip = g.querySelector('[data-r28h-chip][aria-pressed="true"]');
      return chip ? chip.dataset.value : null;
    });
  }

  function fits(variant, sel, skip) {
    for (var j = 0; j < sel.length; j++) {
      if (j === skip) continue;
      if (sel[j] !== null && variant.o[j] !== sel[j]) return false;
    }
    return true;
  }

  function preselect(st) {
    st.groups.forEach(function (g, i) {
      if (g.dataset.kind !== 'colour') return;
      if (g.querySelector('[data-r28h-chip][aria-pressed="true"]')) return;
      var chips = Array.prototype.slice.call(g.querySelectorAll('[data-r28h-chip]'));
      var pick = chips.filter(function (c) {
        return st.variants.some(function (v) { return v.a && v.o[i] === c.dataset.value; });
      })[0] || chips[0];
      if (pick) pick.setAttribute('aria-pressed', 'true');
    });
  }

  function refresh(card) {
    var st = getState(card);
    var sel = selection(st);

    st.groups.forEach(function (g, i) {
      Array.prototype.forEach.call(g.querySelectorAll('[data-r28h-chip]'), function (chip) {
        var ok = st.variants.some(function (v) {
          return v.a && v.o[i] === chip.dataset.value && fits(v, sel, i);
        });
        chip.classList.toggle('is-unavailable', !ok);
      });
    });

    var btn = card.querySelector('[data-r28h-add]');
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;
    var missing = sel.indexOf(null);
    st.variant = null;

    if (missing !== -1) {
      btn.disabled = true;
      btn.textContent = card.dataset.labelSelect + ' ' + st.groups[missing].dataset.name;
      return;
    }
    st.variant = st.variants.filter(function (v) {
      return v.o.every(function (o, k) { return o === sel[k]; });
    })[0] || null;

    if (!st.variant || !st.variant.a) {
      btn.disabled = true;
      btn.textContent = card.dataset.labelSold;
    } else {
      btn.disabled = false;
      btn.textContent = card.dataset.labelAdd;
    }
  }

  function openCard(card) {
    closeAll(card);
    var st = getState(card);
    if (!st.ready) { st.ready = true; preselect(st); }
    var panel = card.querySelector('.r28h__panel');
    card.classList.add('is-open');
    panel.removeAttribute('inert');
    panel.removeAttribute('aria-hidden');
    var plus = card.querySelector('[data-r28h-open]');
    if (plus) plus.setAttribute('aria-expanded', 'true');
    refresh(card);
    requestAnimationFrame(function () {
      var f = panel.querySelector('.r28h__group:not([hidden]) [data-r28h-chip]') ||
              panel.querySelector('[data-r28h-add]:not([disabled])');
      if (f) { try { f.focus({ preventScroll: true }); } catch (e) {} }
    });
  }

  function closeCard(card, returnFocus) {
    var panel = card.querySelector('.r28h__panel');
    card.classList.remove('is-open');
    if (panel) { panel.setAttribute('inert', ''); panel.setAttribute('aria-hidden', 'true'); }
    var plus = card.querySelector('[data-r28h-open]');
    if (plus) {
      plus.setAttribute('aria-expanded', 'false');
      if (returnFocus) { try { plus.focus({ preventScroll: true }); } catch (e) {} }
    }
  }

  function closeAll(except) {
    Array.prototype.forEach.call(document.querySelectorAll('.r28h.is-open'), function (card) {
      if (card !== except) closeCard(card);
    });
  }

  function addToBag(card) {
    var st = getState(card);
    var btn = card.querySelector('[data-r28h-add]');
    if (!st.variant || !st.variant.a || !btn || btn.getAttribute('aria-busy') === 'true') return;

    if (!window.R28Cart || typeof window.R28Cart.add !== 'function') {
      window.location.href = card.dataset.url + '?variant=' + st.variant.id;
      return;
    }

    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    btn.textContent = card.dataset.labelAdding;

    window.R28Cart.add([{ id: st.variant.id, quantity: 1 }], { source: 'r28-hover-card' }).then(
      function () {
        btn.removeAttribute('aria-busy');
        closeCard(card);
        refresh(card);
      },
      function () {
        btn.textContent = card.dataset.labelError;
        setTimeout(function () {
          btn.removeAttribute('aria-busy');
          refresh(card);
        }, 2200);
      }
    );
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var plus = t.closest('[data-r28h-open]');
    if (plus) {
      e.preventDefault();
      var pc = plus.closest('.r28h');
      if (pc.classList.contains('is-open')) closeCard(pc); else openCard(pc);
      return;
    }

    var closer = t.closest('[data-r28h-close], [data-r28h-scrim]');
    if (closer) {
      e.preventDefault();
      closeCard(closer.closest('.r28h'), true);
      return;
    }

    var chip = t.closest('[data-r28h-chip]');
    if (chip) {
      e.preventDefault();
      var card = chip.closest('.r28h');
      Array.prototype.forEach.call(chip.closest('[data-r28h-group]').querySelectorAll('[data-r28h-chip]'), function (c) {
        c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
      });
      refresh(card);
      return;
    }

    var add = t.closest('[data-r28h-add]');
    if (add) {
      e.preventDefault();
      addToBag(add.closest('.r28h'));
      return;
    }

    if (!t.closest('.r28h.is-open')) closeAll();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.r28h.is-open');
    if (open) closeCard(open, true);
  });
})();